<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Compartir Quiniela
                </h2>
                <a routerLink="/quiniela/{{ quiniela.$key }}" *ngIf="this.quiniela.activa"
                    class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                    style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 230px;">
                    <i class="icofont-arrow-left"></i>
                    Volver</a>

                <section id="services" class="services" style="padding: 1rem;width: 100%;max-width: 600px;">

                    <input type="hidden" id="URL" value="{{dominio}}/{{quiniela.url}}">

                    <h2 class="mb-2 animate__animated animate__faster animate__fadeInDown"
                        style="margin-bottom: 0px;font-size: 23px;">
                        Enlace para invitar a otras personas a su quiniela
                    </h2>

                    <div class="container">
                        <div class="container__item">
                            <form class="form">
                                <input type="email" class="form__field" placeholder="Generando su link..."
                                    value="{{dominio}}/{{quiniela.url}}" />
                                <button type="button" (click)="copiarAlPortapapelesURL()"
                                    class="btn btn--primary btn--inside uppercase">Copiar</button>
                            </form>
                        </div>
                    </div>

                    <div class="share-buttons-container">
                        <div class="share-list">

                            <!-- FACEBOOK -->
                            <a class="fb-h" (click)="fbs_click()" target="_blank">
                                <img src="https://img.icons8.com/material-rounded/96/000000/facebook-f.png">
                            </a>

                            <!-- TWITTER -->
                            <a class="tw-h" (click)="tbs_click()" target="_blank">
                                <img src="https://img.icons8.com/material-rounded/96/000000/twitter-squared.png">
                            </a>

                        </div>
                    </div>

                    <!--
                    <h2 class="mt-3 animate__animated animate__faster animate__fadeInDown"
                        style="margin-bottom: 0px;font-size: 23px;">
                        Envía mensajes a los participantes de tus quinielas anteriores
                    </h2>

                    <ol style="--length: 5" role="list">
                        <li style="--i: 5">
                            <h3>Receiving your benefit</h3>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Adipiscing diam donec adipiscing tristique risus.</p>
                        </li>
                    </ol>
                    -->
                    <h2 class="mt-5 mb-2 animate__animated animate__faster animate__fadeInDown"
                        style="margin-bottom: 0px;font-size: 23px;">
                        Generar una imagen para Compartir
                    </h2>

                    <a (click)="takeshot()" id="BotonGenerar"
                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;">
                        Generar imagen para Compartir
                    </a>

                    <div class="alert alert-info" role="alert" id="AlertaImagen" style="display: none;">
                        Puedes descargar o capturar la siguiente <a href="#" class="alert-link">imagen</a> y compartirla
                        con
                        tus amigos o familiares para que se enteren y participen de esta Quiniela.
                    </div>

                    <div id="photo" style="display: none;">
                        <h2 class="mt-4" style="font-size: 30px;">
                            ¡Participa en la Quiniela!
                        </h2>
                        <div class="container">
                            <div class="row">
                                <div class="col-sm">
                                    <p
                                        style='font-weight: 700;margin-bottom: 0.5rem;font-size: 18px;color: white;padding: 0;letter-spacing: 0px;text-transform: uppercase;font-family: "Poppins", sans-serif;'>
                                        {{quiniela.titulo}}</p>
                                    <p style='color: white;font-family: "Poppins", sans-serif;width: 90%;'>
                                        {{quiniela.descripcion}}
                                    </p>
                                    <h4 style="font-size: 36px;color: #ef6603;font-weight: 600;margin-bottom: 0px;">
                                        <sup>{{quiniela.moneda}}</sup>{{quiniela.precio}}
                                    </h4>
                                    <p
                                        style='font-family: "Poppins", sans-serif;text-transform: uppercase;font-weight: 700;'>
                                        Precio</p>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-none d-md-block">
                            <p style='color: white;font-family: "Poppins", sans-serif;width: 90%;'>
                                {{dominio}}/{{quiniela.url}}
                            </p>
                        </div>
                        <div class="d-block d-sm-block d-md-none">
                            <p style='color: white;font-family: "Poppins", sans-serif;width: 90%;font-size: 15px;'>
                                {{dominio}}/{{quiniela.url}}
                            </p>
                        </div>

                    </div>

                    <h1 style="font-size: 15rem;" id="Icono"><i class="icofont-image"></i></h1>
                    <div id="output"></div>


                </section>
                <!--
                <div class="container">
                    <app-loader *ngIf="isLoading"></app-loader>
                    <div *ngIf="!isLoading">
                        <div class="wrp">
                            <a class="icon icon-gplus" href="#">
                                <i class="icofont-link"></i>
                            </a>
                         
                            <a class="icon icon-twitter"
                                href="https://twitter.com/intent/tweet?text=Participa%20en%20la%20quiniela:%20{{dominio}}/{{quiniela.url}}">
                                <i class="icofont-twitter"></i>
                            </a>
                           
                            <a class="icon icon-facebook" href="#">
                                <i class="icofont-facebook"></i>
                            </a>
                            
                            <a class="icon icon-instagram"
                                href="whatsapp://send?text=Participa en la quiniela: {{dominio}}/{{quiniela.url}}">
                                <i class="icofont-brand-whatsapp"></i>
                            </a>
                        </div>
                    </div>
                </div>
 -->



            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section><!-- End Hero -->